var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-rich-text form-item"},[_c('div',{staticClass:"form-item-content"},[_c('x-proxy-form-item',{ref:"formRichText",attrs:{"showRequired":_vm.showRequired,"label":_vm.widget.label,"processTitle":_vm.widget.processTitle,"validatorRules":_vm.validatorRules,"validateKey":_vm.validateKey,"validateInfo":_vm.validateInfo,"disabled":_vm.widget.readOnly}},[(_vm.renderSence === 'read')?_c('quill-editor',{staticClass:"quill-editor-readOnly",attrs:{"content":_vm.formValue,"disabled":true,"options":{
          readOnly: true,
          placeholder: '-',
          modules: {
            toolbar: []
          }
        }}}):_c('quill-editor',{ref:"quillEditor",class:{'quill-readOnly': _vm.widget.readOnly},attrs:{"content":_vm.formValue,"disabled":_vm.widget.readOnly,"options":{
          placeholder: _vm.widget.readOnly ? '' : _vm.widget.placeholder,
          modules: {
            toolbar: {
              container: _vm.widget.readOnly ? [] : _vm.toolbarOptios,
              handlers: {
                'image': _vm.handleImageClick
              }
            }
          }
        }},on:{"change":function($event){return _vm.onChange($event)}}}),_c('input',{ref:"inputImage",staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.accept.toString(),"multiple":""},on:{"change":_vm.handleChange}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }